import { makeAutoObservable, runInAction } from "mobx";
import { onB2BError } from "@/utils/b2bErrors";
/**
 * Заказы активной компании кабинета (UC1130 skeleton → UC1132/1133) — `corp_my_orders`, только чтение.
 * Список и карточка одного заказа делят компанию/фильтры через `init(companyId)`.
 */
export class CorpOrdersStore {
    constructor(ordersService) {
        this.ordersService = ordersService;
        this.orders = [];
        this.filters = {};
        this.isLoading = false;
        this.current = null;
        this.notFound = false;
        this.companyId = null;
        this.generation = 0;
        makeAutoObservable(this, {
            ordersService: false,
            companyId: false,
            generation: false,
        });
    }
    async init(companyId) {
        this.dispose();
        this.companyId = companyId;
        await this.load();
    }
    setFilters(patch) {
        this.filters = { ...this.filters, ...patch };
        void this.load();
    }
    async load() {
        const companyId = this.companyId;
        if (!companyId)
            return;
        const generation = this.generation;
        this.isLoading = true;
        try {
            const orders = await this.ordersService.list(companyId, this.filters);
            runInAction(() => {
                if (generation !== this.generation)
                    return;
                this.orders = orders;
            });
        }
        catch (error) {
            onB2BError(error, "Не удалось загрузить заказы компании", "corpCabinet");
        }
        finally {
            runInAction(() => {
                if (generation === this.generation)
                    this.isLoading = false;
            });
        }
    }
    /**
     * Карточка заказа (UC1133): работает и когда `init()` ещё не вызывался для этого стора
     * (прямой переход на `/corp/orders/:id`) — тогда компанию передаёт вызывающая сторона
     * (`activeCompanyId` из `CorpRootStore`).
     */
    async loadOne(orderId, companyId) {
        if (companyId)
            this.companyId = companyId;
        const resolvedCompanyId = this.companyId;
        if (!resolvedCompanyId)
            return;
        const generation = this.generation;
        this.isLoading = true;
        this.notFound = false;
        try {
            const order = await this.ordersService.getOne(resolvedCompanyId, orderId);
            runInAction(() => {
                if (generation !== this.generation)
                    return;
                this.current = order;
                this.notFound = order === null;
            });
        }
        catch (error) {
            onB2BError(error, "Не удалось загрузить заказ", "corpCabinet");
        }
        finally {
            runInAction(() => {
                if (generation === this.generation)
                    this.isLoading = false;
            });
        }
    }
    get totals() {
        return this.orders.reduce((acc, order) => ({
            orders: acc.orders + 1,
            kwh: acc.kwh + (order.actualTotalKwh ?? 0),
            amount: acc.amount + (order.actualCost ?? 0),
        }), { orders: 0, kwh: 0, amount: 0 });
    }
    dispose() {
        this.generation += 1;
        this.companyId = null;
        this.orders = [];
        this.filters = {};
        this.isLoading = false;
        this.current = null;
        this.notFound = false;
    }
}
